import { ImageActionSheet } from './image-action-sheet';
import { IImageActionSheet, IMobileActionSheetService, IMobileActionSheetServiceDelegates } from './interface';

export class MobileActionSheetService implements IMobileActionSheetService {
    private imageActionSheetInstance: IImageActionSheet;
    private services: IMobileActionSheetServiceDelegates;

    public setServiceDelegates(services: IMobileActionSheetServiceDelegates): void {
        this.services = services;
    }

    public get imageActionSheet(): IImageActionSheet {
        if (!this.imageActionSheetInstance) {
            this.imageActionSheetInstance = new ImageActionSheet(this.services);
        }

        return this.imageActionSheetInstance;
    }
}
